import { useEffect } from "react";

import { useSetAtom } from "jotai";

import { detectExtensionGate } from "@prostocheck/kep";
import { isExtensionGateConnectedAtom } from "@prostocheck/shared";

/**
 * Checks once, at app start, whether the jkurwa-web gate browser extension is
 * installed, and writes the answer into `isExtensionGateConnectedAtom` — the
 * login banner and the app shell's badge both read it from there. See
 * ai/docs/kep-signing.md.
 *
 * Not a `get<Thing>` action hook like `useZReports`: there is no ДПС read
 * here, just one background check, called directly from `App` next to
 * `useDocumentLanguage`.
 */
export const useExtensionGate = (): void => {
  const setIsConnected = useSetAtom(isExtensionGateConnectedAtom);

  useEffect(() => {
    let isCurrent = true;

    void detectExtensionGate().then(isAvailable => {
      if (!isCurrent) return;

      setIsConnected(isAvailable);
    });

    return () => {
      isCurrent = false;
    };
  }, [setIsConnected]);
};
